import React, { useContext, useState, useRef, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from 'app/AuthContext';
import Module from 'sub-components/module/Module';
import { FormModal, SignInForm } from 'sub-components';
import { getEnvConfig } from 'lib/utils';



const SignInModal = (props) => {
    const { authToken, userMetadata, logout } = useContext(AuthContext);
    const [actionCompleted, setActionCompleted] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    const [actionCompletedType, setActionCompletedType] = useState(null);
    const navigate = useNavigate();
    const [isSignInToggleOn, setIsSignInToggleOn] = useState(false);

    const messaging = getEnvConfig().messaging;

    const handleActionCompleted = (actionType) => {
        if (actionType) { setActionCompletedType(actionType); }
        setActionCompleted(true);
    };

    useEffect(() => {
        if (!userMetadata) return;
        if (userMetadata && (userMetadata.last_successful_login_ts === null || userMetadata.last_successful_login_ts < 1744948800000) ) {
            navigate(`/onboarding/${userMetadata?.id}`);
        } else {
            navigate(`/discovery`);
        }
    }, [userMetadata]);

    return (
        <FormModal
            isToggleOn={isSignInToggleOn || props.isSignInToggleOn}
            handleClick={props.handleClick}
            onClose={() => {
                clearTimeout(timeoutId);
                setActionCompleted(false);
            }}
            actionCompleted={actionCompleted}
            title={messaging.sign_in.ui.title}
            successfulActionTitle={messaging.sign_in.ui.success.title}
            successfulActionMessage={
                <div>{messaging.sign_in.ui.success.msg}</div>
            }>
            <SignInForm handleSignUpClick={props.handleSignUpClick} onActionCompleted={handleActionCompleted} resetPwdClick={props.resetPwdClick} />
        </FormModal>
    );
};

export default SignInModal;